import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";
import { showSuccessNotification } from "@utils/showNotification";

import { patientQKeys } from "@hooks/queries/patient/queryKeys";
import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";

import { PatientMedicalHistoryItem } from "@customTypes/patient";


export const useCreateMedicalRecord = () => {
  const queryClient = useQueryClient();
  const handleErrors = useQueryErrorHandling();

  return useMutation({
    mutationFn: (data: PatientMedicalHistoryItem) => {
      return api.post(`patient/conditions/`, {
        patient_id: data.patientId,
        date: data.date,
        condition: data.condition,
        condition_origin: data.origin,
        status: data.status,
      });
    },
    onSuccess: res => {
      // console.log(res.data);
      showSuccessNotification({
        title: "success",
        message: "create-medical-record-success",
      });
      queryClient.invalidateQueries({
        queryKey: patientQKeys.medicalHistory(res.data.patient_id),
      });
    },

    onError: res => {
      console.error("[From Create Medical Record]", res);

      handleErrors(res, "mutation");
    },
  });
};
